// stores/useFamilyEnquiriesFilterStore.ts
import { create } from "zustand";

interface FamilyEnquiriesFilterState {
  openEnquiriesModal: boolean;
  startDate: string;
  endDate: string;
  schemeKeyword: string;
  stateId: number | null;
  categoryId: number | null;
  districtId: number | null;
  gender: number | null;
  ageFrom: number | null;
  ageTo: number | null;
  governmentType: number | null;
  applyFilter: boolean;
  searchVal:string

  // setters
  setOpenEnquiriesModal: (val: boolean) => void;
  setStartDate: (val: string) => void;
  setEndDate: (val: string) => void;
  setSchemeKeyword: (val: string) => void;
  setStateId: (val: number | null) => void;
  setCategoryId: (val: number | null) => void;
  setDistrictId: (val: number | null) => void;
  setGender: (val: number | null) => void;
  setAgeFrom: (val: number | null) => void;
  setAgeTo: (val: number | null) => void;
  setGovernmentType: (val: number | null) => void;
  setApplyFilter: (val: boolean) => void;
  setSearchValue: (val: string) => void;

  resetFilter: () => void;
}

export const useFamilyEnquiriesFilterStore = create<FamilyEnquiriesFilterState>(
  (set, get) => ({
    openEnquiriesModal: false,
    startDate: "",
    endDate: "",
    schemeKeyword: "",
    stateId: null,
    categoryId: null,
    districtId: null,
    gender: null,
    ageFrom: null,
    ageTo: null,
    governmentType: null,
    applyFilter: true,
    searchVal:'',

    setOpenEnquiriesModal: (val) => set({ openEnquiriesModal: val }),
    setStartDate: (val) => set({ startDate: val }),
    setEndDate: (val) => set({ endDate: val }),
    setSchemeKeyword: (val) => set({ schemeKeyword: val }),
    setStateId: (val) => set({ stateId: val }),
    setCategoryId: (val) => set({ categoryId: val }),
    setDistrictId: (val) => set({ districtId: val }),
    setGender: (val) => set({ gender: val }),
    setAgeFrom: (val) => set({ ageFrom: val }),
    setAgeTo: (val) => set({ ageTo: val }),
    setGovernmentType: (val) => set({ governmentType: val }),
    setApplyFilter: (val) => set({ applyFilter: val }),
    setSearchValue:(val)=>set({searchVal:val}),

    resetFilter: () =>
      set({
        startDate: "",
        endDate: "",
        schemeKeyword: "",
        stateId: null,
        categoryId: null,
        districtId: null,
        gender: null,
        ageFrom: null,
        ageTo: null,
        governmentType: null,
        openEnquiriesModal: false,
        searchVal:''
      }),
  })
);


export const useActiveFamilyFilterCount = () => {
  const {
    startDate,
    endDate,
    schemeKeyword,
    stateId,
    categoryId,
    ageTo,
    gender,
    districtId,
    ageFrom,
    searchVal,
    governmentType,
  } = useFamilyEnquiriesFilterStore();

  let count = 0;
  if (startDate) count++;
  if (endDate) count++;
  if (schemeKeyword) count++;
  if (stateId !== null) count++;
  if (categoryId !== null) count++;
  if (ageTo !== null) count++;
  if (ageFrom !== null) count++;
  if (gender) count++;
  if (districtId !== null) count++;
  if (searchVal) count++;
  if (governmentType !== null) count++;

  return count;
};
